import React, { Fragment, useMemo } from 'react';
import { FormattedNumber } from 'react-intl';

import { calculateSummaryAmountLines } from 'businessLogic/server/scsToIcnAdapter';
import DataRow from 'components/Shared/DataRow/DataRow';
import Hr from 'components/Shared/Hr/Hr';
import { useIsMobileScreen } from 'hooks/useIsMobile';
import { colors } from 'styles/cp';
import { LineItem } from 'types/Sale';

export interface Props {
  currency: string;
  lines: LineItem[];
  opened: boolean;
  linesWithoutOTF?: LineItem[];
  onlyOTFLines?: LineItem[];
}

const SubscriptionDetails: React.FC<Props> = ({
  lines,
  currency,
  opened,
  linesWithoutOTF,
  onlyOTFLines,
}) => {
  const subTotalAmount = useMemo(() => calculateSummaryAmountLines(lines).subTotalAmount, [lines]);

  const isMobile = useIsMobileScreen(768);
  const borderColor = useMemo(() => (isMobile ? colors.gray07 : colors.offWhite), [isMobile]);

  return (
    <Fragment>
      {opened && (
        <div className="details-wrapper">
          <ul className="no-margin">
            {linesWithoutOTF?.map(({ item, amount }, i) => {
              return (
                <div key={`invoice-item-line-${i}`}>
                  <DataRow
                    regular={true}
                    margin="8px 0px"
                    key={`invoice-item-line-${i}`}
                    idValue="''"
                    defaultMessage={item?.name as string}
                    value={
                      <span className="invoice-item-value">
                        <FormattedNumber value={amount} style="currency" currency={currency} />
                      </span>
                    }
                  />
                </div>
              );
            })}
            {onlyOTFLines && onlyOTFLines?.length > 0 && (
              <>
                {linesWithoutOTF && linesWithoutOTF?.length > 0 && (
                  <Hr marginTop={12} marginBottom={12} borderColor={borderColor} opacity={1} />
                )}
                {onlyOTFLines?.map((line, idx) => (
                  <DataRow
                    key={`one-time-fee-line-${idx}`}
                    regular={true}
                    margin="8px 0px"
                    defaultMessage={`${line.item.name} (one-time)`}
                    idValue="''"
                    value={
                      <span className="invoice-item-value">
                        <FormattedNumber value={line.amount} style="currency" currency={currency} />
                      </span>
                    }
                  />
                ))}
              </>
            )}
            <Hr marginTop={12} marginBottom={12} borderColor={borderColor} opacity={1} />
            {subTotalAmount && (
              <DataRow
                regular={true}
                margin="8px 0px"
                idValue={'SUBTOTAL'}
                defaultMessage={'subtotal'}
                value={
                  <FormattedNumber value={subTotalAmount} style="currency" currency={currency} />
                }
              />
            )}
          </ul>
        </div>
      )}

      <style jsx>{`
        font-family: AvenirNextforINTUIT-Regular;
        line-height: 20px;
        .no-margin {
          margin: 0;
          padding: 0;
        }
        .summary-lines {
          margin: 12px 0 0 40%;
        }
        .invoice-item-value {
          white-space: nowrap;
        }
      `}</style>
    </Fragment>
  );
};

export default SubscriptionDetails;
